import { Loader } from '../../../../Loader/Loader';

export const LoadingIndicator = () => {
  return <Loader size='medium' backgroundColor='transparent' />;
};
